const axiosUrl = "https://pdhanewala.com:9004/";
const createEvent = "event/createEvent";
const updateEvent = "event/updateEvent";
const deleteEvent = "event/deleteEvent";
const getAllEvents = "event/getAllEvents";
const createCoupon = "coupons/createCoupon";
const updateCoupon = "coupons/updateCoupon";
const deleteCoupon = "coupons/deleteCoupon";
const getAllCoupons = "coupons/getAllCoupons";
const userLogin = "user/userLogin";
const verifyOtp = "user/verify-otp";
const userLogout = "user/userLogout";
export default {
  axiosUrl,
  createEvent,
  updateEvent,
  deleteEvent,
  getAllEvents,
  createCoupon,
  updateCoupon,
  deleteCoupon,
  getAllCoupons,
  userLogin,
  verifyOtp,
  userLogout,
};
